import { getConfig } from "api";

const config = (store) => {
  store.on("@init", () => ({ config: null }));
  store.on("config/set", (_, config) => {
    return { config };
  });

  store.on("config/get", async () => {
    try {
      const config = await getConfig();
      store.dispatch("config/set", config);
    } catch (err) {
      console.error(`Config fetch failed ${err.message}`);
      store.dispatch("notification/error", err.message);
    }
  });
};

export default config;
